import styled from 'styled-components/macro';
// @ts-ignore, there is no type
import shouldForwardProp from '@styled-system/should-forward-prop';

import {
  compose,
  typography,
  space,
  position,
  flexbox,
  color,
  border,
  layout,
} from 'styled-system';

/**
 * @ignore - do not document.
 */
const Box = styled('div').withConfig({
  shouldForwardProp,
})`
  ${compose(space, position, flexbox, typography, layout, color, border)}
  ${({ cursor }) => (cursor ? `cursor: ${cursor}` : '')}
`;

Box.displayName = 'Box';

export default Box;
